export default __webpack_public_path__ + "static/media/CourseImage1.430c62ba.jpg";